import { RealObject } from '@tb-core/types';

class SessionStorageService {
    /**
     * Gets & returns sessionStorage items as fully parsed out values ready for consumption.
     */
    getItems() {
        // Parse each entry.
        return Object.entries(window.sessionStorage).reduce(
            (acc: RealObject, [key, value]: [string, string]) => {
                value = value.trim();

                try {
                    acc[key] =
                        // JSON test
                        /^{.*}$/.test(value)
                            ? JSON.parse(value)
                            : // Number test
                            /^\d$/.test(value)
                            ? Number(value)
                            : // Truthy test
                            value === 'true'
                            ? true
                            : // Falsy test
                            value === 'false'
                            ? false
                            : // Use raw value.
                              value;
                } catch (e) {
                    throw Error(e);
                }

                return acc;
            },
            {}
        );
    }

    /**
     * Iterates items to set each one to sessionStorage.
     * @param items An object containing entries as key/value pairs.
     */
    setItems(items: RealObject) {
        Object.entries(items).forEach(([key, value]) =>
            window.sessionStorage.setItem(key, JSON.stringify(value))
        );
    }
}

export default new SessionStorageService();
